import c from "react";
import { ChevronLeft as g } from "@olxbr/ds-icons";
import { cls as v } from "../../helpers/cls.js";
var y = Object.defineProperty,
  u = Object.getOwnPropertySymbols,
  E = Object.prototype.hasOwnProperty,
  O = Object.prototype.propertyIsEnumerable,
  d = (e, t, r) => t in e ? y(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r,
  S = (e, t) => {
    for (var r in t || (t = {})) E.call(t, r) && d(e, r, t[r]);
    if (u) for (var r of u(t)) O.call(t, r) && d(e, r, t[r]);
    return e;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const p = e => {
    switch (e) {
      case "left":
        return 0;
      case "up":
        return 90;
      case "right":
        return 180;
      case "down":
        return 270;
    }
    return 0;
  },
  w = (e, t, r, a, o) => {
    switch (r) {
      case "up":
      case "down":
        return {
          "--width": a,
          "--height": o,
          "--min-width": t,
          "--min-height": e
        };
      case "right":
      case "left":
      default:
        return {
          "--width": a,
          "--height": o,
          "--min-width": e,
          "--min-height": t
        };
    }
  },
  s = _ref => {
    let {
      direction: e = "left",
      disabled: t,
      color: r = "default",
      width: a = "28px",
      height: o = "48px",
      expandClickableArea: i,
      onClick: l,
      "aria-label": b
    } = _ref;
    const h = "28px",
      f = "48px",
      m = p(e),
      _ = w(h, f, e, a, o),
      x = n => {
        n.stopPropagation(), n.preventDefault(), l == null || l(n);
      };
    return c.createElement("button", {
      "data-ds-component": "DS-ArrowButton",
      className: v("olx-arrow-button", r === "inverted" && "olx-arrow-button--inverted", "olx-arrow-button--".concat(e), i && "olx-arrow-button--expand-clickable-area", i && "olx-arrow-button--expand-clickable-area--".concat(e)),
      onClick: x,
      disabled: !!t,
      color: r,
      "aria-label": b,
      style: S({
        "--rotation": "".concat(m, "deg")
      }, _)
    }, c.createElement(g, null));
  };
s.displayName = "ArrowButton";
export { s as ArrowButton, p as calculateRotation, w as getPositionedDimensions };